module.exports = __webpack_public_path__ + "prod/1.42.2/img/cycle-six.17298a56.png";